import Page from 'src/apipages/upload/thumbnails/index';

export default Page;
